import type { Socket } from "socket.io-client";
import { env } from "@/lib/env";

// socket.io-client is dynamically imported instead of loaded at module scope
// so its JS isn't parsed/executed as part of the app-wide critical bundle that
// every route (including the homepage) has to hydrate through — it's only
// pulled in once CartSocketProvider actually mounts, after first paint.
let socketPromise: Promise<Socket> | null = null;

export function getSocket(): Promise<Socket> {
    if (!socketPromise) {
        socketPromise = import("socket.io-client").then(({ io }) =>
            io(env.API_URL, {
                transports: ["websocket"],
                withCredentials: false,
                autoConnect: false,
            })
        );
    }
    return socketPromise;
}
